var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_2589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_2589)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#F1361D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0723 3.10076L11.0407 3.26586L11.767 3.92736L11.9322 2.95891L12.5936 2.23258L11.6252 2.06747L10.8989 1.40598L10.7338 2.37442L10.0723 3.10076ZM12.6663 6.48803L13.5055 5.97728L14.4877 6L13.9769 5.16079L13.9996 4.17863L13.1604 4.68938L12.1783 4.66667L12.689 5.50588L12.6663 6.48803ZM11.5279 11.9709L10.707 12.5106L10.6954 11.5282L10.1557 10.7074L11.138 10.6958L11.9589 10.1561L11.9705 11.1384L12.5102 11.9593L11.5279 11.9709ZM12.2408 9.43144L13.2172 9.32321L14.0977 9.75887L13.9895 8.78243L14.4252 7.9019L13.4487 8.01013L12.5682 7.57446L12.6764 8.5509L12.2408 9.43144Z",
    fill: "#FFDC42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 8.22667L4.31585 9.90274L5.18334 7.14874L2.86277 5.4306L5.75005 5.40461L6.66699 2.66667L7.58394 5.40461L10.4712 5.4306L8.15064 7.14874L9.01813 9.90274L6.66699 8.22667Z",
    fill: "#FFDC42"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.a55a7358a6e9705daaacd13e655d9fe9.svg";
export { ForwardRef as ReactComponent };